export function strToTags(str?: string): string[] {
  const selectValue: string[] = [];
  if (str) {
    const splitValue = str.split(/[(\r\n)\r\n]+/);
    splitValue.forEach(item => {
      const currentValue = item.trim();
      if (currentValue) selectValue.push(currentValue);
    });
  }
  return selectValue;
}
